import moreButton from './moreButton.vue';

export default moreButton;
